import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { User, Type, Palette, Badge, Plus } from 'lucide-react';
import AppleHeader from '../../components/AppleHeader';

export const AnadirAEscena: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const idsParam = params.get('ids') || '';
  const ids = useMemo(() => idsParam.split(',').map(s => s.trim()).filter(Boolean), [idsParam]);

  const handleBack = () => {
    const qp = new URLSearchParams();
    if (ids.length > 0) qp.set('ids', ids.join(','));
    const query = qp.toString();
    navigate(query ? `/redes-sociales/crear-anuncio/prueba-nueva-interfaz?${query}` : '/redes-sociales/crear-anuncio/prueba-nueva-interfaz');
  };

  const options: Array<{
    key: string;
    title: string;
    description: string;
    Icon: React.ComponentType<any>;
    colorBg: string;
    colorText: string;
  }> = [
    { key: 'modelo', title: 'Modelo', description: 'Agregá una persona o modelo a la escena.', Icon: User, colorBg: 'bg-blue-50', colorText: 'text-blue-600' },
    { key: 'texto', title: 'Texto', description: 'Insertá frases o slogans en la composición.', Icon: Type, colorBg: 'bg-purple-50', colorText: 'text-purple-600' },
    { key: 'colores', title: 'Colores', description: 'Definí paletas o acentos de color de la escena.', Icon: Palette, colorBg: 'bg-green-50', colorText: 'text-green-600' },
    { key: 'logo', title: 'Logo', description: 'Incluí tu logo para aparecer en la imagen.', Icon: Badge, colorBg: 'bg-orange-50', colorText: 'text-orange-600' },
  ];

  return (
    <div className="p-4 sm:p-8 sm:pb-0 max-w-4xl mx-auto min-h-[100dvh] md:min-h-screen bg-white sm:bg-transparent">
      <div className="sm:bg-white sm:rounded-2xl sm:shadow-sm p-0 sm:p-6">
        <AppleHeader title="Añadir a la escena" onBack={handleBack} actionLabel="Listo" onAction={handleBack} />

        <div className="mt-4">
          <div className="w-full h-1 bg-transparent rounded-full" />
        </div>

        <div className="mt-6 space-y-3">
          {options.map(({ key, title, description, Icon, colorBg, colorText }) => (
            <button
              key={key}
              type="button"
              className="w-full text-left border border-gray-200 rounded-2xl p-4 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-start gap-3">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${colorBg}`}>
                    <Icon className={`w-5 h-5 ${colorText}`} />
                  </div>
                  <div className="flex-1">
                    <p className="text-gray-900 font-semibold text-sm">{title}</p>
                    <p className="text-gray-600 text-sm mt-1">{description}</p>
                  </div>
                </div>
                <div className="shrink-0 w-8 h-8 rounded-full bg-gray-50 text-gray-400 flex items-center justify-center">
                  <Plus className="w-4 h-4" />
                </div>
              </div>
            </button>
          ))}
        </div>

      </div>

    </div>
  );
};

export default AnadirAEscena;
